<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span @click="back" style="cursor: pointer">焦炭</span> > 行业动态</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>行业动态</p>
        <div class="btn fr" @click="get">搜索</div>
        <input class="fr" type="text" placeholder="请输入关键词" v-model="likeTitleName">
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p @click="item.newsType===1?goDetail( item.id):goWailian(item.newsContent)">{{ item.titleName }}</p>
          <span class="fr">{{ item.showYearTime }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;" @click="homePage">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="size"
          :current-page="page"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="lastPage">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  industryPage
} from '@/api/coke'

export default {
  name: "secondaryPage",
  props: [
    'queryObj'
  ],
  data() {
    return {
      list: [],
      page: 1,
      size: 15,
      total: 0,
      likeTitleName: ""
    }
  },
  created() {
    this.getList({pageNum: this.page, likeTitleName: this.likeTitleName,pageSize: this.size, sourceType:1});
  },
  methods: {
    // 获取列表
    getList() {
      industryPage({pageNum: this.page, likeTitleName: this.likeTitleName,pageSize: this.size, sourceType:1}).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    get(){
      this.page = 1
      this.getList()

    },
    /**
     * 前往详情页
     */
    goDetail(id) {
      this.$router.push({path:`/coke/industry`, query:{id}})
    },
    /**
     * 外链打开
     */
    goWailian(url) {
      window.openUrl(url, "_blank");
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/coke')
    },
    /**
     * 分页
     */
    changePage(page) {
      this.page = page;
      this.getList({pageNum: this.page, pageSize: this.size, sourceType:1})
    },
     /**
     * 首页
     */
    homePage(){
      this.changePage(1)
    },
    /**
     * 末页
     */
    lastPage(){
      let cpage = Math.ceil(this.total / this.size);
      this.changePage(cpage)
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
